import { forwardRef, useId, type InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  /** Help/validation text shown under the field. */
  hint?: string;
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, hint, invalid = false, id, className = '', ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const classes = ['form-control', invalid ? 'is-invalid' : '', className].filter(Boolean).join(' ');

  return (
    <div className="mb-3">
      {label && (
        <label className="form-label" htmlFor={inputId}>
          {label}
        </label>
      )}
      <input id={inputId} ref={ref} className={classes} {...rest} />
      {hint && <div className={invalid ? 'invalid-feedback d-block' : 'form-text'}>{hint}</div>}
    </div>
  );
});
